import { Component, HostListener, ViewChild } from '@angular/core';
import { GlobalService } from '../../service/global.service';
import { CommonModule } from '@angular/common';
import { LoginComponent } from '../../modals/login/login.component';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HttpService } from '../../service/http.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    LoginComponent,
    RouterModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

  loginPopuptype: string = 'login'

  productCategory: any[] = [];

  isLoginPopup: boolean = false;

  /** Toggles the compact / frosted header once the page is scrolled. */
  isScrolled: boolean = false;

  @HostListener('window:scroll')
  onWindowScroll(): void {
    const y = window.scrollY || document.documentElement.scrollTop || 0;
    this.isScrolled = y > 24;
  }

  showList: boolean = false;
  menuList = [
    // {
    //   "name": "Talk to Lawyers",
    //   "redirectUrl": "talk-to-advisor",
    //   "isActive": true
    // },
    // {
    //   "name": "ITR Filling",
    //   "redirectUrl": "products/tax-and-compliance",
    //   "isActive": true
    // },
    // {
    //   "name": "Company Registration",
    //   "redirectUrl": "products/startup",
    //   "isActive": true
    // },
    // {
    //   "name": "Agreement",
    //   "redirectUrl": "products/agreement",
    //   "isActive": true
    // },
    // {
    //   "name": "About Us",
    //   "redirectUrl": "about-us",
    //   "isActive": true
    // }
  ]

  constructor(private _homeService: HttpService, private route: Router,
    private _router: ActivatedRoute, public gS: GlobalService) {

    console.log('header is open');
    //  this.gS.userName=localStorage.getItem('userfullname');
    this.gS.userName = JSON.parse(localStorage.getItem('userfullname')!);

  }

  openLoginPopup(login: string) {
    this.isLoginPopup = true;
    this.loginPopuptype = login;
  }

  closeLoginPopup() {
    this.isLoginPopup = false;
  }


  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this._homeService.getAllProductsByCategory(this.gS.customerId).subscribe((data: any) => {
      if (data?.data) {
        this.productCategory = data?.data?.productCategory;
        console.log(this.productCategory, 'productData');
      }
    }, (error) => {
      console.log(error);
    });
  }
  isMenuOpen = false;

  toggleNavbar() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  
  closeNavbar() {
    this.isMenuOpen = false;
  }
  
}
